import http from "@http"
//角色列表  不分页
export function getDictDataAll(data) {
    return http({
        url: '/lskj-admin/api/admin/dictData/all',
        method: "post",
        data
    })
}
//角色列表  分页
export function getDictDataList(data) {
    return http({
        url: '/lskj-admin/api/admin/dictData/list',
        method: "post",
        data
    })
}

//查询单条角色信息
export function dictDataById(data) {
    return http({
        url: `/lskj-admin/api/admin/dictData/byId?id=${data.id}`,
        method: "get",
    })
}

//添加部门
export function dictDataAdd(data) {
    return http({
        url: '/lskj-admin/api/admin/dictData/add',
        method: "post",
        data
    })
}

//修改部门信息
export function updeteDictData(data) {
    return http({
        url: `/lskj-admin/api/admin/dictData`,
        method: "put",
        data
    })
}
//删除部门信息
export function deleteDictData(data) {
    return http({
        url: `/lskj-admin/api/admin/dictData?ids=${data.ids}`,
        method: "delete",
        data
    })
}